import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

export const RentalCarInfoBox: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <div className={"bg-white rounded-md mt-4 px-4 py-3 text-neutral-700"}>
      <p className={"text-sm"}>
        <b>Ersatzwagen:</b> Bitte kontaktieren Sie Ayvens nach der Werkstattbuchung unter{" "}
        <a
          href={t("hotline.hotline-phone-link")}
          className={"text-neutral-700 no-underline font-normal"}
        >
          {t("hotline.hotline-phone")}
        </a>{" "}
        (Mo - Do 8:00 - 18:00 Uhr und Fr 8:00 - 17:00 Uhr)
      </p>
    </div>
  );
};
